import { CommonModule, JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-test',
  standalone: true,
  imports: [CommonModule, FormsModule, JsonPipe],
  templateUrl: './test.component.html',
  styleUrl: './test.component.scss'
})
export class TestComponent {
  EmployeeDetail = {
    SelectType: 'ei',
    FirstName: null,
    EmailId: null,
    MobileNo: null,
    EmpTempCode: "",
    RegistrationType: 'Manual',
    EmployeeCategory: 'Front',
    IsDraft: true,
  }

  InsertUpdate() {
    console.log(this.EmployeeDetail);
  }

  Validate(form: any) {
    if (form.valid) {
      this.InsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }
}


// app.component.ts
// import { Component, OnInit, OnDestroy } from '@angular/core';
// import { MicrosoftAuthService } from './../../Model/MicrosoftAuth/microsoft-auth.service';

// @Component({
//   selector: 'app-test',
//   template: `
//     <div class="auth-container">
//       <!-- Login Button -->
//       <button (click)="signIn()" [disabled]="isLoading" class="btn btn-primary">
//         {{ isLoading ? 'Signing in...' : 'Sign in with Microsoft' }}
//       </button>

//       <!-- Logout Button -->
//       <button *ngIf="isAuthenticated" (click)="signOut()" class="btn btn-secondary">
//         Sign Out
//       </button>

//       <!-- Cancel Button (when loading) -->
//       <button *ngIf="isLoading" (click)="cancelSignIn()" class="btn btn-warning">
//         Cancel
//       </button>

//       <!-- User Info -->
//       <div *ngIf="userInfo" class="user-info">
//         <h4>Welcome, {{ userInfo.name }}</h4>
//         <p>Email: {{ userInfo.email }}</p>
//       </div>

//       <!-- Error Message -->
//       <div *ngIf="errorMessage" class="alert alert-danger">
//         {{ errorMessage }}
//         <button *ngIf="errorMessage.includes('interaction_in_progress')" 
//                 (click)="retrySignIn()" class="btn btn-sm btn-outline-light ml-2">
//           Retry
//         </button>
//       </div>
//     </div>
//   `,
//   styles: [`
//     .auth-container {
//       padding: 20px;
//       text-align: center;
//     }
//     .user-info {
//       margin-top: 20px;
//       padding: 15px;
//       background: #f5f5f5;
//       border-radius: 5px;
//     }
//     button {
//       margin: 10px;
//       padding: 10px 20px;
//       min-width: 150px;
//     }
//     .alert {
//       margin: 20px auto;
//       padding: 15px;
//       max-width: 600px;
//       border-radius: 5px;
//     }
//   `]
// })
// export class TestComponent implements OnInit, OnDestroy {
//   isLoading = false;
//   isAuthenticated = false;
//   userInfo: any = null;
//   errorMessage = '';
//   private signInAttempts = 0;
//   private maxAttempts = 3;

//   constructor(private authService: MicrosoftAuthService) { }

//   ngOnInit() {
//     this.checkAuthentication();
//     // Listen for popup close events
//     window.addEventListener('beforeunload', this.handlePopupClose.bind(this));
//   }

//   ngOnDestroy() {
//     window.removeEventListener('beforeunload', this.handlePopupClose.bind(this));
//   }

//   async signIn() {
//     if (this.signInAttempts >= this.maxAttempts) {
//       this.errorMessage = 'Too many attempts. Please refresh the page.';
//       return;
//     }

//     this.isLoading = true;
//     this.errorMessage = '';
//     this.signInAttempts++;

//     try {
//       // Sign in
//       const response = await this.authService.signIn();
//       console.log('Sign in response:', response);

//       // Reset attempts on success
//       this.signInAttempts = 0;

//       // Get user profile
//       await this.getUserProfile();

//     } catch (error: any) {
//       console.error('Authentication error:', error);

//       if (error.errorCode === 'interaction_in_progress') {
//         this.errorMessage = 'Another sign-in attempt is already in progress. ';
//         this.errorMessage += 'If no window opened, wait a moment and try again or click Retry.';

//         // Wait and auto-retry once
//         if (this.signInAttempts === 1) {
//           setTimeout(() => {
//             if (this.isLoading) {
//               this.retrySignIn();
//             }
//           }, 2000);
//         }
//       } else {
//         this.errorMessage = error.errorMessage || error.message || 'Authentication failed';
//       }

//       this.isLoading = false;
//     }
//   }

//   retrySignIn() {
//     this.errorMessage = '';
//     this.signIn();
//   }

//   cancelSignIn() {
//     this.isLoading = false;
//     this.errorMessage = 'Sign in cancelled';
//     this.signInAttempts = 0;

//     // Try to clear any pending interactions
//     this.authService.handlePopupClose();
//   }

//   async getUserProfile() {
//     try {
//       const profile = await this.authService.getUserProfile();

//       if (profile) {
//         this.handleSuccessfulLogin(profile);
//       } else {
//         throw new Error('Failed to get user profile');
//       }
//     } catch (error: any) {
//       this.errorMessage = 'Failed to load user profile: ' + (error.message || 'Unknown error');
//       this.isLoading = false;
//     }
//   }

//   signOut() {
//     this.authService.signOut();
//     this.isAuthenticated = false;
//     this.userInfo = null;
//     this.errorMessage = '';
//     this.signInAttempts = 0;
//   }

//   private checkAuthentication() {
//     this.isAuthenticated = this.authService.isAuthenticated();

//     if (this.isAuthenticated) {
//       const user = this.authService.getCurrentUser();
//       if (user) {
//         this.userInfo = {
//           name: user.name || 'Unknown',
//           email: user.username || 'No email'
//         };
//       }
//     }
//   }

//   private handleSuccessfulLogin(profile: any) {
//     this.isLoading = false;
//     this.isAuthenticated = true;

//     this.userInfo = {
//       name: profile.displayName || profile.userPrincipalName,
//       email: profile.mail || profile.userPrincipalName,
//       id: profile.id
//     };

//     // Call your backend API
//     this.callBackendLogin(profile);
//   }

//   private callBackendLogin(profile: any) {
//     const loginData = {
//       Email: profile.mail || profile.userPrincipalName,
//       Password: '',
//       EmpAouthID: profile.id,
//       RememberMe: false
//     };

//     console.log('Backend login data:', loginData);
//   }

//   private handlePopupClose() {
//     // This is called when the window is closing
//     if (this.isLoading) {
//       this.cancelSignIn();
//     }
//   }
// }

// components/login/login.component.ts
// import { Component, OnInit } from '@angular/core';
// import { CommonModule} from '@angular/common';
// import { Router } from '@angular/router';
// import { MsalCdnService } from './../../Model/MicrosoftAuth/msal-cdn.service';

// @Component({
//   selector: 'app-test',
//   standalone: true,
//   imports: [CommonModule],
//   template: `
//     <div class="login-container">
//       <h2>Sign in to Call Log Application</h2>
      
//       <div *ngIf="!serviceReady" class="loading">
//         <p>Loading authentication service...</p>
//       </div>
      
//       <div *ngIf="serviceReady">
//         <div *ngIf="!isAuthenticated">
//           <button 
//             (click)="signIn()" 
//             [disabled]="isLoading"
//             class="btn btn-microsoft">
//             <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjUgMjFDNC43MDEwMSAyMSAwIDE2LjI5OSAwIDEwLjVDMCA0LjcwMTAxIDQuNzAxMDEgMCAxMC41IDBDMTYuMjk5IDAgMjEgNC43MDEwMSAyMSAxMC41QzIxIDE2LjI5OSAxNi4yOTkgMjEgMTAuNSAyMVoiIGZpbGw9IiNGQTUyMjUiLz4KPHBhdGggZD0iTTE1LjY0MzIgOC40MjU3OEgxMC44NjY2VjEyLjU3MTJIMTUuNjQzMlY4LjQyNTc4WiIgZmlsbD0iIzgwQkI0RCIvPgo8cGF0aCBkPSJNMTAuNSAwQzEzLjI4OTkgMCAxNS44ODc4IDEuMTQxNDUgMTcuNjQzMiAyLjk1Njc4TDE0LjU3MTUgNi4wMjg0N0MxMy43ODU1IDUuMjQyNDYgMTIuNzM0MiA0Ljc4NTcxIDExLjU3MTIgNC43ODU3MUM4Ljg1NDYzIDQuNzg1NzEgNi42NDI4NSA3IDYuNjQyODUgOS43MTY1OUM2LjY0Mjg1IDEyLjQzMzMgOC44NTQ2MyAxNC42NDUxIDExLjU3MTIgMTQuNjQ1MUMxMi43MzQyIDE0LjY0NTEgMTMuNzg1NSAxNC4xODgzIDE0LjU3MTUgMTMuNDAyMkwxNy42NDMyIDE2LjQ3MzlDMTUuODg3OCAxOC4yODkyIDEzLjI4OTkgMTkuNDMwNyAxMC41IDE5LjQzMDdDNi4wNzEwMiAxOS40MzA3IDIuNTY5MjggMTUuOTI5IDIuNTY5MjggMTEuNUMyLjU2OTI4IDcuMDcxMDIgNi4wNzEwMiAzLjU2OTI4IDEwLjUgMy41NjkyOFYwWiIgZmlsbD0iIzIzNUE5NCIvPgo8L3N2Zz4=" 
//             alt="Microsoft Logo" 
//             class="microsoft-logo">
//             Sign in with Microsoft
//           </button>
//         </div>
        
//         <div *ngIf="isAuthenticated && userInfo" class="user-info">
//           <h3>Welcome, {{ userInfo.displayName }}</h3>
//           <p>{{ userInfo.mail || userInfo.userPrincipalName }}</p>
//           <button (click)="signOut()" class="btn btn-logout">Sign Out</button>
//         </div>
        
//         <div *ngIf="error" class="error-message">
//           {{ error }}
//         </div>
        
//         <div *ngIf="isLoading" class="loading">
//           <p>Processing authentication...</p>
//         </div>
//       </div>
//     </div>
//   `,
//   styles: [`
//     /* Keep your existing styles */
//     .login-container {
//       max-width: 400px;
//       margin: 50px auto;
//       padding: 30px;
//       border-radius: 8px;
//       box-shadow: 0 2px 10px rgba(0,0,0,0.1);
//       text-align: center;
//     }
    
//     .loading {
//       padding: 20px;
//       color: #666;
//     }
    
//     .btn-microsoft {
//       background: #2F2F2F;
//       color: white;
//       border: none;
//       padding: 12px 24px;
//       border-radius: 4px;
//       font-size: 16px;
//       cursor: pointer;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       gap: 10px;
//       width: 100%;
//       margin: 20px 0;
//     }
    
//     .btn-microsoft:hover {
//       background: #404040;
//     }
    
//     .btn-microsoft:disabled {
//       background: #ccc;
//       cursor: not-allowed;
//     }
    
//     .microsoft-logo {
//       width: 20px;
//       height: 20px;
//     }
    
//     .btn-logout {
//       background: #dc3545;
//       color: white;
//       border: none;
//       padding: 8px 16px;
//       border-radius: 4px;
//       cursor: pointer;
//       margin-top: 10px;
//     }
    
//     .btn-logout:hover {
//       background: #c82333;
//     }
    
//     .error-message {
//       color: #dc3545;
//       background: #f8d7da;
//       padding: 10px;
//       border-radius: 4px;
//       margin: 10px 0;
//     }
    
//     .user-info {
//       background: #f8f9fa;
//       padding: 20px;
//       border-radius: 4px;
//       margin-top: 20px;
//     }
//   `]
// })
// export class TestComponent implements OnInit {
//   serviceReady = false;
//   isLoading = false;
//   isAuthenticated = false;
//   error = '';
//   userInfo: any = null;

//   constructor(
//     private authService: MsalCdnService,
//     private router: Router
//   ) {}

//   async ngOnInit() {
//     try {
//       // Initialize service
//       this.serviceReady = true;
      
//       // Check for redirect response
//       await this.handleRedirectCallback();
      
//       // Check authentication
//       await this.checkAuthentication();
      
//     } catch (error) {
//       console.error('Component initialization error:', error);
//       this.error = 'Failed to initialize authentication';
//     }
//   }

//   async handleRedirectCallback() {
//     try {
//       // Handle any redirect callback
//       const response = await this.authService.handleRedirectCallback();
//       if (response) {
//         console.log('Redirect callback handled:', response);
//         this.isLoading = false;
//         await this.checkAuthentication();
//       }
//     } catch (error) {
//       console.error('Redirect callback error:', error);
//     }
//   }

//   async signIn() {
//     this.isLoading = true;
//     this.error = '';

//     try {
//       // This will redirect to Microsoft login
//       await this.authService.signIn();
//       // User will be redirected, so we don't need to do anything else here
//     } catch (error: any) {
//       console.error('Sign in error:', error);
//       this.isLoading = false;
//       this.error = error.errorMessage || error.message || 'Authentication failed';
//     }
//   }

//   signOut() {
//     this.authService.signOut();
//     // User will be redirected, so clear local state
//     this.isAuthenticated = false;
//     this.userInfo = null;
//   }

//   private async checkAuthentication() {
//     this.isLoading = true;
    
//     try {
//       // Check if already authenticated
//       const authenticated = this.authService.isAuthenticated();
      
//       if (authenticated) {
//         this.isAuthenticated = true;
        
//         // Get user profile
//         const profile = await this.authService.getUserProfile();
//         if (profile) {
//           this.userInfo = profile;
//         }
//       }
      
//       this.isLoading = false;
//     } catch (error) {
//       console.error('Failed to check authentication:', error);
//       this.isLoading = false;
//     }
//   }
// }